<template>
  <v-list class="app-sidebar-root">
    <v-card class="app-sidebar-card">
      <v-layout>
        <v-navigation-drawer v-model="drawer" :rail="rail" permanent @click="rail = false" class="app-sidebar">
          <div class="app-sidebar-toggle">
            <v-btn class="app-sidebar-button" variant="text" icon="mdi-menu" @click.stop.prevent="toggleRail"></v-btn>
          </div>
          <v-list-item class="app-sidebar-user" :prepend-avatar="User.urlimage" :title="User.nome" nav>
           <template v-slot:append>
              <v-btn class="app-sidebar-button" variant="text" icon="mdi-export" @click.stop="Logout()"></v-btn>
            </template>
          </v-list-item>  
          <hr class="app-sidebar-divider" />
          <v-list v-for="item in menuAgentes" :key="item.title">
            <v-list-group :value="item.title">
              <template v-slot:activator="{ props }"><v-list-item v-bind="props" :title="item.title" prepend-icon="mdi-robot-outline" class="app-sidebar-item"></v-list-item></template>
              <v-list-item v-for="subItem in item.subItems" :key="subItem.title" :title="subItem.title" :to="subItem.link" prepend-icon="mdi-circle-small" class="app-sidebar-subitem"></v-list-item>
            </v-list-group>
          </v-list>
          <div v-if="ehUsuarioAvanceDigital()">
          <v-list v-for="item in menuItems" :key="item">
              <v-list-group :value="item.title">
                <template v-slot:activator="{ props }">
                  <v-list-item v-bind="props" :title="item.title" prepend-icon="mdi-cog-outline" class="app-sidebar-item"></v-list-item>
                </template>
                 <v-list-item v-for="subItem in item.subItems" :key="subItem.title" :value="subItem.title" :title="subItem.title" :to="subItem.link" prepend-icon="mdi-circle-small" class="app-sidebar-subitem">
              </v-list-item>
            </v-list-group>
          </v-list>
        </div>
          <div v-if="QtdeSegInst > 0">
          <v-list v-for="item in menuSegInst" :key="item">
              <v-list-group :value="item.title">
                <template v-slot:activator="{ props }">
                  <v-list-item v-bind="props" :title="item.title" prepend-icon="mdi-pencil" class="app-sidebar-item"></v-list-item>
                </template>
                 <v-list-item v-for="subItem in item.subItems" :key="subItem.title" :value="subItem.title" :title="subItem.title" :to="subItem.link" prepend-icon="mdi-circle-small" class="app-sidebar-subitem">
              </v-list-item>
            </v-list-group>
          </v-list>
        </div>
          <v-list v-for="itemi in GrupoTelasInst" :key="itemi.gtiId">
              <v-list-group :value="itemi.gtiNome">
                <template v-slot:activator="{ props }">
                  <v-list-item v-bind="props" :title="itemi.gtiNome" :prepend-icon="itemi.gtiIcon" class="app-sidebar-item"></v-list-item>
                </template>
                 <v-list-item v-for="subItemi in TelasInst.filter(x=> x.admGrupoTelasInst.gtiId == itemi.gtiId)" :key="subItemi.ctiId" :value="subItemi.ctiNome" :title="subItemi.ctiNome" :to="'/institucional/' + subItemi.ctiId + '/' + subItemi.ctiUrl" prepend-icon="mdi-circle-small" class="app-sidebar-subitem">
              </v-list-item>
            </v-list-group>
          </v-list>
        </v-navigation-drawer>
        <v-main style="min-height: 1200px;"></v-main>
      </v-layout>
    </v-card>
  </v-list>
</template>

<script>
import axios from 'axios';
export default {
  name: 'PageHeader',
  components: {
  },
  data: () => ({
    drawer: true,
    rail: false,
    isSidebarVisible: false,
    isDropdownOpen: false,
    menuItems: [
      {
        title: 'Adm Institucional', isOpen: false, subItems: [
          { title: 'Cadastro Grupo Institucional', link: '/GrupoTelasInstitucional' },
          { title: 'Cadastro Telas Institucional', link: '/CadastroTelasInstitucional' },
          { title: 'Configura Institucional', link: '/ConfigInstitucional' },
          { title: 'Configura Imgs Institucional', link: '/ConfigListaImagens' },
          { title: 'Configura Arqs Institucional', link: '/ConfigListaArquivos' },
          { title: 'Configura Grids Institucional', link: '/ConfigListaGrids' },
          { title: 'Importar JSON Institucional', link: '/ImportacaoInstitucional' },
          { title: 'Cadastro Tipos de Usuário ', link: '/CadastroTipoUsuario' },
          { title: 'Cadastro Usuários', link: '/CadastroUsuarios' },
          { title: 'Controle Permissões', link: '/ControlePermissoes' },
        ]
      },
    ],
    menuAgentes: [{ title: 'Agentes IA', subItems: [{ title: 'Dashboard e Agentes', link: '/AdminAgentes' }] }],
    menuSegInst: [
      {
        title: 'Segmentos Inst', isOpen: false, subItems: [
          { title: 'Cadastro Segmentos', link: '/SegmentosInst' },
        ]
      },
    ],
    QtdeSegInst: 0,
    TelasInst:[],
    GrupoTelasInst:[],
    User: {
      cusId: 0,
      nome: '',
      urlimage: '/images/userNo.png',
      menu: []
    },
  }),
  methods: {
    ehUsuarioAvanceDigital() {
      return parseInt(this.User.cusId) === 2 || (this.User.nome || '').toLowerCase().includes('avance');
    },
    toggleMenu(item) {
      item.isOpen = !item.isOpen;
    },
    toggleSidebar() {
      this.isSidebarVisible = !this.isSidebarVisible;
    },
    toggleDropdown() {
      this.isDropdownOpen = !this.isDropdownOpen;
    },
    checkLogin() {
      const valorArmazenado = sessionStorage.getItem('_userav');
      if (!valorArmazenado) {
        this.$router.push('/')
      }
    },
    dadosUsuarioSessao(dados) {
      return {
        cusId: dados.cusId || dados.CusId || 0,
        nome: dados.nome || dados.Nome || '',
        urlimage: dados.urlimage || dados.urlImage || dados.UrlImage || '',
        menu: dados.menu || dados.Menu || []
      };
    },
    aplicaUsuario(dados) {
      this.User = this.dadosUsuarioSessao(dados);
      if (!this.User.menu) {
        this.User.menu = [];
      }

      if (this.User.urlimage == '') {
        this.User.urlimage = "/images/userNo.png";
      }
      else if (!this.User.urlimage.startsWith(this.$imgURL)) {
        this.User.urlimage = this.$imgURL + this.User.urlimage;
      }
    },
    carregaUsuarioSessao() {
      const valorArmazenado = sessionStorage.getItem('_userav');
      if (!valorArmazenado) {
        this.$router.push('/');
        return false;
      }

      this.aplicaUsuario(JSON.parse(valorArmazenado));
      return true;
    },
    Logout() {
            axios.post('/Auth/Logout').finally(() => {
            sessionStorage.removeItem('_userav');
            this.$router.push('/');
            });
        },
    toggleRail(event) {
      if (event) {
        event.preventDefault();
      }
      this.rail = !this.rail;
    },
    ordenaPorOrdem(campo) {
      return (a, b) => {
        const valorA = parseInt(a[campo]) || 0;
        const valorB = parseInt(b[campo]) || 0;
        return valorA - valorB;
      };
    },
    montaMenuInstitucional(grupos, telas) {
      this.TelasInst = telas
        .filter(x => x.ctiVisivel)
        .sort(this.ordenaPorOrdem('ctiOrdem'))
        .filter(tela => this.User.menu.some(item => item.cdtId === tela.ctiId && item.cusTipo === 2));

      this.GrupoTelasInst = grupos
        .filter(x => x.gtiVisivel)
        .sort(this.ordenaPorOrdem('gtiOrdem'))
        .filter(grupo => this.TelasInst.some(tela => tela.admGrupoTelasInst && tela.admGrupoTelasInst.gtiId === grupo.gtiId));
    },
    async carregaMenus() {
      const [grupoTelasInst, cadastroTelasInst, qtdSegInst] = await Promise.all([
        axios.get(`/Process/AdmGrupoTelasInst/GetAll`),
        axios.get(`Process/AdmCadastroTelasInst/GetAll`),
        axios.get(`/Process/AdmConfigTelaInstitucional/GetByQtdSegImg`).catch(() => ({ data: 0 }))
      ]);

      this.montaMenuInstitucional(grupoTelasInst.data, cadastroTelasInst.data);
      this.QtdeSegInst = qtdSegInst.data;
    },
    async recarregaMenuUsuario() {
      const valorArmazenado = sessionStorage.getItem('_userav');
      if (!valorArmazenado) {
        return;
      }

      this.aplicaUsuario(JSON.parse(valorArmazenado));
      await this.carregaMenus();
    },
  },
  created() {
    const usuarioCarregado = this.carregaUsuarioSessao();
    if (!usuarioCarregado) {
      return;
    }

    if (window.innerWidth <= 768){
      this.rail = true;
    }

    this.carregaMenus();
  },
  mounted() {
    window.addEventListener('sgcad-menu-refresh', this.recarregaMenuUsuario);
  },
  beforeUnmount() {
    window.removeEventListener('sgcad-menu-refresh', this.recarregaMenuUsuario);
  },

}
</script>

<style>
.white-text{
  color:#ffffff;
}

.app-sidebar-root,
.app-sidebar-card {
  background: transparent !important;
  border-radius: 0 !important;
  box-shadow: none !important;
}

.app-sidebar {
  background: linear-gradient(180deg, #172331 0%, #24384c 100%) !important;
  border-right: 1px solid rgba(255,255,255,.08);
}

.app-sidebar-user,
.app-sidebar-item,
.app-sidebar-subitem,
.app-sidebar-button {
  color: #f8fafc !important;
}

.app-sidebar-toggle {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  min-height: 62px !important;
  padding: 0 10px;
}

.app-sidebar-user {
  background: rgba(255,255,255,.06);
  border-radius: 8px;
  margin: 8px 10px 10px;
}

.app-sidebar-divider {
  border: 0;
  border-bottom: 1px solid rgba(255,255,255,.12);
  margin: 8px 12px;
}

.app-sidebar-item,
.app-sidebar-subitem {
  border-radius: 7px !important;
  margin: 2px 8px;
}

.app-sidebar-subitem {
  color: #dbe7f3 !important;
}

.app-sidebar-item:hover,
.app-sidebar-subitem:hover,
.v-list-item--active {
  background: rgba(47, 111, 115, .38) !important;
}

.v-list-group__items .v-list-item {
    -webkit-padding-start: 8px !important;
    padding-inline-start: 8px !important;
}

.v-list-item-title{
  font-size: 12.5px !important;
  font-weight: 650;
}

.v-list-item--density-default.v-list-item--one-line {
    min-height: 34px !important;
    padding-top: 4px;
    padding-bottom: 4px;
}

.v-list {
    padding: 0px 0 !important;
}

</style>
